import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { M3_TO_BBL, E3M3_TO_MCF } from './conversionFactors';

const zip = new JSZip();

const MONTH_LENGTH = 30.436875;


export const exportDataHelper = (name, type, units, wellUwis, selectedLists, typeCurveIds, groupWellIds, lists, wells, typeCurves, groupWells, showForecast) => {

  try {
    let wellsArray = [];

    if (selectedLists?.length > 0) {
      selectedLists.forEach(listId => { // Construct wells array
        lists.byId[listId]?.wellUwis?.forEach(uwi => {
          if (wells?.byUwi[uwi]?.production || wells?.byUwi[uwi]?.forecast) wellsArray.push(wells.byUwi[uwi]);
        });
      });
    };
    if (typeCurveIds?.length > 0) {
      typeCurveIds.forEach(typeCurveId => { // Construct type curves array
        if (typeCurves?.byId[typeCurveId]?.forecast) wellsArray.push(typeCurves.byId[typeCurveId]);
      });
    };
    if (groupWellIds?.length > 0) {
      groupWellIds.forEach(groupWellId => { // Construct group wells array
        if (groupWells?.byId[groupWellId]?.forecast) wellsArray.push(groupWells.byId[groupWellId]);
      });
    };
    if (wellUwis?.length > 0) {
      wellUwis.forEach(wellUwi => { // Construct UWIs array
        if (wells?.byUwi[wellUwi]?.production || wells?.byUwi[wellUwi]?.forecast) wellsArray.push(wells.byUwi[wellUwi]);
      });
    };

    let productionCSV = "";
    let eurCSV = "";

    let keys = [
      'name',
      'id', 
      'fluid', 
      'date', 
      'monthsOnline', 
      `volumeP90 (${getUnits(units)})`, 
      `volumeP50 (${getUnits(units)})`, 
      `volumeP10 (${getUnits(units)})`, 
      `rateP90 (${getUnits(units)}/d)`, 
      `rateP50 (${getUnits(units)}/d)`, 
      `rateP10 (${getUnits(units)}/d)`, 
      `cumP90 (${getUnits(units)})`, 
      `cumP50 (${getUnits(units)})`, 
      `cumP10 (${getUnits(units)})`
    ];
    productionCSV += keys.join(",") + "\r\n";

    const addProductionValues = (well, fluid, newDrill, productionOnly) => {
      try {
        if (newDrill || productionOnly) {
          well?.production?.byFluid?.[fluid]?.length > 0 && well?.production?.byFluid?.[fluid]?.forEach(row => {
            let values = [];
  
            for (let key of keys) {
              values.push(getValue((well?.formattedUwi || well?.name), (well?.uwi || well?.id), row, fluid, key?.split(' ')?.[0], units, true));
            };
  
            values = values.join(",");
            productionCSV += values + "\r\n";
          });
        } else {
          const lastProductionMonth = well?.production?.byFluid?.[fluid]?.slice(-1)?.[0]?.monthsOnline;

          well?.production?.byFluid?.[fluid]?.length > 0 && well?.production?.byFluid?.[fluid]?.forEach(row => { // add all of production
            let values = [];
  
            for (let key of keys) {
              values.push(getValue((well?.formattedUwi || well?.name), (well?.uwi || well?.id), row, fluid, key?.split(' ')?.[0], units, true));
            };
  
            values = values.join(",");
            productionCSV += values + "\r\n";
          });            

          well?.forecast?.byFluid?.[fluid]?.length > 0 && well?.forecast?.byFluid?.[fluid]?.filter(f => f.monthsOnline > lastProductionMonth)?.forEach(row => { // add forecast
            let values = [];
            
            for (let key of keys) {
              values.push(getValue((well?.formattedUwi || well?.name), (well?.uwi || well?.id), row, fluid, key?.split(' ')?.[0], units, false));
            };
  
            values = values.join(",");
            productionCSV += values + "\r\n";
          });
        };
      } catch (error) {
        return;
      };
    };

    const eurKeys = ['name', 'id', 'fluid', `p90 ${getUnits(units)}`, `p50 ${getUnits(units)}`, `p10 ${getUnits(units)}`];
    eurCSV += eurKeys.join(",") + "\r\n";

    const addEurValues = (well, fluid, units) => {
      try {
        let values = [((well?.formattedUwi || well?.uwi) || well?.name), (well?.uwi || well?.id), fluid];
        ['p10', 'p50', 'p90'].forEach(prob => {
          let value = well?.eur?.byFluid?.[fluid]?.[prob]?.cumVolume * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF)) || 0;
          values.push(value.toFixed(2));
        });
        values = values.join(",");
        eurCSV += values + "\r\n";

      } catch (error) {
        return;
      };
    };

    wellsArray?.forEach(well => {
      if (well?.production?.byFluid?.oil?.length > 0 || well?.forecast?.byFluid?.oil?.length > 0) addProductionValues(well, 'oil', well.copy, showForecast === 'Hide');
      if (well?.eur?.byFluid?.oil) addEurValues(well, 'oil');
      if (well?.production?.byFluid?.gas?.length > 0 || well?.forecast?.byFluid?.gas?.length > 0) addProductionValues(well, 'gas', well.copy, showForecast === 'Hide');
      if (well?.eur?.byFluid?.gas) addEurValues(well, 'gas');
      if (well?.production?.byFluid?.condensate?.length > 0 || well?.forecast?.byFluid?.condensate?.length > 0) addProductionValues(well, 'condensate', well.copy, showForecast === 'Hide');
      if (well?.eur?.byFluid?.condensate) addEurValues(well, 'condensate');
      if (well?.production?.byFluid?.water?.length > 0 || well?.forecast?.byFluid?.water?.length > 0) addProductionValues(well, 'water', well.copy, showForecast === 'Hide');
      if (well?.eur?.byFluid?.water) addEurValues(well, 'water');
    });

    zip.file(`${name}-production-${units}.csv`, productionCSV);
    zip.file(`${name}-eur-${units}.csv`, eurCSV);

    zip.generateAsync({type: "blob"}).then(content => {
      saveAs(content, `${name}-${units}.zip`);
    });

    return true;
  } catch (error) {
    console.log(error);
    return false;
  };

  function getValue(name, id, row, fluid, key, units, newDrill) {
    try {
      switch(key) {
        case 'name':
          return name;
        case 'id':
          return id;
        case 'fluid':
          return fluid;
        case 'date':
          return new Date(row.date)?.toISOString()?.split('T')?.[0];
        case 'monthsOnline':
          return row.monthsOnline;
        case 'volumeP90':
          return ((newDrill ? row.volume : row.volume.p90) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF))).toFixed(2);
        case 'volumeP50':
          return ((newDrill ? row.volume : row.volume.p50) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF))).toFixed(2);
        case 'volumeP10':
          return ((newDrill ? row.volume : row.volume.p10) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF))).toFixed(2);
        case 'rateP90':
          return ((newDrill ? row.volume : row.volume.p90) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF)) / MONTH_LENGTH).toFixed(2);
        case 'rateP50':
          return ((newDrill ? row.volume : row.volume.p50) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF)) / MONTH_LENGTH).toFixed(2);
        case 'rateP10':
          return ((newDrill ? row.volume : row.volume.p10) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF)) / MONTH_LENGTH).toFixed(2);
        case 'cumP90':
          return ((newDrill ? row.cumVolume : row.cumVolume.p90) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF))).toFixed(2);
        case 'cumP50':
          return ((newDrill ? row.cumVolume : row.cumVolume.p50) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF))).toFixed(2);
        case 'cumP10':
          return ((newDrill ? row.cumVolume : row.cumVolume.p10) * (units === 'metric' ? 1 : ((fluid === 'oil' || fluid === 'condensate' || fluid === 'water') ? M3_TO_BBL : E3M3_TO_MCF))).toFixed(2);
        default:
          break;
      };
    } catch (error) {
      console.log(error);
      return 0;
    };
  };

  function getUnits(units) {
    switch(units) {
      case 'metric':
        return 'm3 or E3m3';
      case 'imperial':
        return 'bbl or mcf';
      default:
        return '';
    };
  };
};